/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  EstimatedActivity,
  EstimatedActivity$inboundSchema,
  EstimatedActivity$Outbound,
  EstimatedActivity$outboundSchema,
} from "./estimatedactivity.js";

export type SendFundsAch = {
  estimatedActivity?: EstimatedActivity | undefined;
};

/** @internal */
export const SendFundsAch$inboundSchema: z.ZodType<
  SendFundsAch,
  z.ZodTypeDef,
  unknown
> = z.object({
  estimatedActivity: EstimatedActivity$inboundSchema.optional(),
});
/** @internal */
export type SendFundsAch$Outbound = {
  estimatedActivity?: EstimatedActivity$Outbound | undefined;
};

/** @internal */
export const SendFundsAch$outboundSchema: z.ZodType<
  SendFundsAch$Outbound,
  z.ZodTypeDef,
  SendFundsAch
> = z.object({
  estimatedActivity: EstimatedActivity$outboundSchema.optional(),
});

export function sendFundsAchToJSON(sendFundsAch: SendFundsAch): string {
  return JSON.stringify(SendFundsAch$outboundSchema.parse(sendFundsAch));
}
export function sendFundsAchFromJSON(
  jsonString: string,
): SafeParseResult<SendFundsAch, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SendFundsAch$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SendFundsAch' from JSON`,
  );
}
